// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compoff-container {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 40vw;
  min-height: 60vh; /* allows the box to grow with content */
  max-height: 80vh; /* prevents it from taking entire screen */
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* enables scroll if content overflows */
}
.compoff-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.compoff-header h2 {
  font-size: 1.3rem;
  color: #333;
}

.add-btn {
  /* background: #007bff; */
  color: #fff;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.add-btn:hover {
  background: #77bea4;
}

.calendar-container {
  margin: 15px 0;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  z-index: 1;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
  margin-top: 10px;
}

.calendar-day,
.calendar-empty {
  text-align: center;
  padding: 8px;
  border-radius: 6px;
  background: #f9f9f9;
  cursor: pointer;
  transition: 0.2s;
}

.calendar-day:hover {
  background: #dbeafe;
}

.calendar-day-header {
  font-weight: bold;
  text-align: center;
}

.compoff-entries {
  margin-top: 20px;
}

.compoff-table-header {
  display: grid;
  grid-template-columns: 0.8fr 0.6fr 1fr 1fr 0.2fr;
  align-items: center;
  font-weight: 600;
  color: #444;
  margin-bottom: 10px;
  text-align: left;
}

.compoff-row {
  display: grid;
  grid-template-columns: 0.8fr 0.5fr 0.9fr 1fr 0.2fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.compoff-row input,
.compoff-row select {
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
}

.remove-btn {
  background: #f4f4f4;
  color: #333;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  padding: 6px 10px;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  background: #e0e0e0;
  color: #000;
}

.compoff-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto; /* pushes buttons to bottom of container */
  padding-top: 15px;
  background: #fff; /* ensures buttons visible even when scrolling */
  position: sticky;
  bottom: 0; /* makes buttons stick at bottom */
}

.cancel-btn,
.submit-btn {
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.cancel-btn {
  background: #b5afaf4c;
}

.submit-btn {
  background: #84c7ae;
  color: #fff;
}

.submit-btn:hover {
  background: #77bea4;
}
.calendar-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  background: #fdfdfd;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 60px;
}

.calendar-day:hover {
  background: #e8f7f1;
}

.calendar-date {
  font-weight: 600;
  font-size: 1rem;
  color: #333;
}

.calendar-hours {
  font-size: 0.75rem;
  color: #555;
  margin-top: 2px;
}

/* Highlight days with valid hours */
.calendar-day.has-hours {
  background: #f5fff9;
  border: 1px solid #cdeedb;
}

/* Optional: better grid spacing */
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-top: 10px;
}


.compoff-container::-webkit-scrollbar {
  width: 6px;
}

.compoff-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.compoff-container::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Request/ApplyRequests/CompOff/CompOff.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,gBAAgB,EAAE,wCAAwC;EAC1D,gBAAgB,EAAE,0CAA0C;EAC5D,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,wCAAwC;AAC5D;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB,EAAE,0CAA0C;EAC5D,iBAAiB;EACjB,gBAAgB,EAAE,gDAAgD;EAClE,gBAAgB;EAChB,SAAS,EAAE,kCAAkC;AAC/C;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".compoff-container {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 40vw;\n  min-height: 60vh; /* allows the box to grow with content */\n  max-height: 80vh; /* prevents it from taking entire screen */\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto; /* enables scroll if content overflows */\n}\n.compoff-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.compoff-header h2 {\n  font-size: 1.3rem;\n  color: #333;\n}\n\n.add-btn {\n  /* background: #007bff; */\n  color: #fff;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.add-btn:hover {\n  background: #77bea4;\n}\n\n.calendar-container {\n  margin: 15px 0;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 10px;\n  z-index: 1;\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.calendar-day,\n.calendar-empty {\n  text-align: center;\n  padding: 8px;\n  border-radius: 6px;\n  background: #f9f9f9;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.calendar-day:hover {\n  background: #dbeafe;\n}\n\n.calendar-day-header {\n  font-weight: bold;\n  text-align: center;\n}\n\n.compoff-entries {\n  margin-top: 20px;\n}\n\n.compoff-table-header {\n  display: grid;\n  grid-template-columns: 0.8fr 0.6fr 1fr 1fr 0.2fr;\n  align-items: center;\n  font-weight: 600;\n  color: #444;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.compoff-row {\n  display: grid;\n  grid-template-columns: 0.8fr 0.5fr 0.9fr 1fr 0.2fr;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.compoff-row input,\n.compoff-row select {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 0.95rem;\n}\n\n.remove-btn {\n  background: #f4f4f4;\n  color: #333;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 6px 10px;\n  font-weight: bold;\n  font-size: 1rem;\n  text-align: center;\n  transition: all 0.2s ease;\n}\n\n.remove-btn:hover {\n  background: #e0e0e0;\n  color: #000;\n}\n\n.compoff-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: auto; /* pushes buttons to bottom of container */\n  padding-top: 15px;\n  background: #fff; /* ensures buttons visible even when scrolling */\n  position: sticky;\n  bottom: 0; /* makes buttons stick at bottom */\n}\n\n.cancel-btn,\n.submit-btn {\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.cancel-btn {\n  background: #b5afaf4c;\n}\n\n.submit-btn {\n  background: #84c7ae;\n  color: #fff;\n}\n\n.submit-btn:hover {\n  background: #77bea4;\n}\n.calendar-day {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0;\n  background: #fdfdfd;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 60px;\n}\n\n.calendar-day:hover {\n  background: #e8f7f1;\n}\n\n.calendar-date {\n  font-weight: 600;\n  font-size: 1rem;\n  color: #333;\n}\n\n.calendar-hours {\n  font-size: 0.75rem;\n  color: #555;\n  margin-top: 2px;\n}\n\n/* Highlight days with valid hours */\n.calendar-day.has-hours {\n  background: #f5fff9;\n  border: 1px solid #cdeedb;\n}\n\n/* Optional: better grid spacing */\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n  margin-top: 10px;\n}\n\n\n.compoff-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.compoff-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.compoff-container::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
